import React from 'react';

import { buildClassNames } from '../../utils';

export const ListItem: React.FC<React.ComponentProps<'li'>> = ({ className, ...props }) => {
  const classNames = buildClassNames('dropdown-menu-item', className);
  return <li className={classNames} {...props} />;
};
